import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value", "label", "additional"],
  _excluded2 = ["defaultValue", "radios", "value", "onChange", "type", "layout"];
var _TYPE_VS_RADIO_TYPE;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';

// Lodash
import _map from 'lodash/map';
import _values from 'lodash/values';

// Components
import { Radio } from 'antd';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import isStringEmpty from '@tekion/tekion-base/utils/isStringEmpty';
import Icon from '../FontIcon';

// Constants

// Styles
import './radio.scss';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
var RadioGroup = Radio.Group;
var RadioButton = Radio.Button;
export var RADIO_BUTTON_LAYOUTS = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL'
};
export var RADIO_TYPES = {
  RADIO: 'RADIO',
  RADIO_BUTTON: 'RADIO_BUTTON'
};
export var TYPE_VS_RADIO_TYPE = (_TYPE_VS_RADIO_TYPE = {}, _defineProperty(_TYPE_VS_RADIO_TYPE, RADIO_TYPES.RADIO, Radio), _defineProperty(_TYPE_VS_RADIO_TYPE, RADIO_TYPES.RADIO_BUTTON, RadioButton), _TYPE_VS_RADIO_TYPE);
var RadioAsGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RadioAsGroup, _React$PureComponent);
  var _super = _createSuper(RadioAsGroup);
  function RadioAsGroup() {
    var _this;
    _classCallCheck(this, RadioAsGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderRadioOptions", function (Component) {
      return function (_ref) {
        var value = _ref.value,
          label = _ref.label,
          _ref$additional = _ref.additional,
          additional = _ref$additional === void 0 ? EMPTY_OBJECT : _ref$additional,
          restProps = _objectWithoutProperties(_ref, _excluded);
        var icon = additional.icon,
          iconSize = additional.iconSize,
          _additional$iconClass = additional.iconClassName,
          iconClassName = _additional$iconClass === void 0 ? '' : _additional$iconClass;
        return /*#__PURE__*/React.createElement(Component, _extends({
          value: value,
          key: value
        }, restProps), icon && /*#__PURE__*/React.createElement(Icon, {
          className: iconClassName,
          size: iconSize
        }, icon), label);
      };
    });
    return _this;
  }
  _createClass(RadioAsGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultValue = _this$props.defaultValue,
        radios = _this$props.radios,
        value = _this$props.value,
        onChange = _this$props.onChange,
        type = _this$props.type,
        layout = _this$props.layout,
        rest = _objectWithoutProperties(_this$props, _excluded2);
      var radioOptions = _map(radios, this.renderRadioOptions(TYPE_VS_RADIO_TYPE[type]));
      return /*#__PURE__*/React.createElement(RadioGroup, _extends({}, rest, {
        onChange: onChange,
        value: isStringEmpty(value) ? defaultValue : value
      }), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: layout === RADIO_BUTTON_LAYOUTS.VERTICAL,
        fallback: radioOptions
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex flex-column"
      }, radioOptions)));
    }
  }]);
  return RadioAsGroup;
}(React.PureComponent);
_defineProperty(RadioAsGroup, "propTypes", {
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  radios: PropTypes.oneOf(_values(RADIO_BUTTON_LAYOUTS)),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  layout: PropTypes.string
});
_defineProperty(RadioAsGroup, "defaultProps", {
  defaultValue: '',
  radios: [],
  value: '',
  type: 'RADIO',
  layout: RADIO_BUTTON_LAYOUTS.HORIZONTAL
});
export default RadioAsGroup;